import { USER_CARD_SMALL_MODE } from './constants'

export const getAdditionalText = (additionalText, mode) => {
  if (!additionalText) {
    return ''
  }

  if (Array.isArray(additionalText)) {
    return additionalText.join(', ')
  }

  if (mode === USER_CARD_SMALL_MODE.MODAL) {
    return additionalText.split(' ').join(', ')
  }

  return additionalText
}
